var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGoodIcon = function SvgGoodIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.165,
    height: 29
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5656",
    transform: "translate(-.064)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 366",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(.229)",
    fill: "#fdd402"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3832",
    d: "M4.01 14.437A14.439 14.439 0 0116.474.137a14.437 14.437 0 100 28.6 14.439 14.439 0 01-12.464-14.3z",
    fill: "#fbbf13"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3833",
    d: "M14.891 24.567h-.465a8.8 8.8 0 01-8.5-6.474.5.5 0 11.962-.264 7.807 7.807 0 007.535 5.74h.465a7.818 7.818 0 007.535-5.741.5.5 0 01.962.264 8.805 8.805 0 01-8.494 6.475zm-4.388-11.569a.5.5 0 01-.5-.5 1.363 1.363 0 00-2.726 0 .5.5 0 01-1 0 2.36 2.36 0 014.721 0 .5.5 0 01-.5.5z",
    fill: "#74563a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 367",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(19.229 8)",
    fill: "#74563a"
  }))));
};
export default SvgGoodIcon;